import { FieldProps, getIn } from 'formik';
import * as React from 'react';
import { BaseFileUploader, IBaseFileUploaderProps } from '../../';

type IFileUploaderFieldProps = IBaseFileUploaderProps & FieldProps;

/**
 * Wrapper around FileUploader to be able to work with Form components
 */
export const FileUploaderField = React.memo<IFileUploaderFieldProps>(props => {
    const {
        field: { name, value },
        form: { errors, setFieldValue, isValidating },
        ...otherProps
    } = props;

    const error = getIn(errors, name);

    const errorMessage: string | undefined = isValidating && error ? error : undefined;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const file = e.target.files ? e.target.files[0] : null;

        setFieldValue(name, file);
    };

    return (
        <BaseFileUploader
            value={value}
            {...otherProps}
            errorMessage={errorMessage}
            onChange={handleChange}
            name={name}
        />
    );
});
